.gridContainer {
  margin-bottom: var(--grid-container-margin-bottom);
  margin-left: var(--grid-container-margin-left);
}
